import React from 'react';

import './player-team.scss';
import { makeClassNames } from '../../../utils/styles';
import Cta from '../cta/cta';

const classNames = () =>
  makeClassNames({
    team: 'player-card__team',
  });

export interface IPlayerTeam {
  imageUrl: string;
  teamName: string;
  teamUrl?: string;
  lazy?: boolean;
  trackingDataValue?: string;
}

const PlayerTeam = (props: IPlayerTeam) => {
  const { imageUrl, teamName, teamUrl, lazy = false, trackingDataValue } = props;

  const cn = classNames();

  const teamLogo = <img src={lazy ? undefined : imageUrl} data-src={lazy ? imageUrl : undefined} alt={teamName} />;

  if (teamUrl) {
    return (
      <Cta
        href={teamUrl}
        aria-label={teamName}
        title={teamName}
        className={cn.team}
        trackingData={trackingDataValue ? { intcmp: trackingDataValue } : undefined} // skysport_${type}_logo-squadra_detail-link
      >
        {teamLogo}
      </Cta>
    );
  } else {
    return <div className={cn.team}> {teamLogo}</div>;
  }
};

export default PlayerTeam;
